require("./loanInsuraceDetail.scss");

// @ vendor
import React from "react";
const { withRouter } = require("react-router-dom");
const PropTypes = require("prop-types");
const { formatText, FormattedText } = require("core/i18n").i18n;

// @ commons
const { OKSectionBox } = require("commonsComponents/OKSectionBox");
const { OKBoxTitle } = require("commonsComponents/OKBoxTitle");
const { OKMessage } = require("commonsComponents/OKMessage");
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const OKInformativeListItem = require("components/rebrand/OKInformativeListItem/OKInformativeListItem");
const { recordLinkV2 } = require("utilities/tagging");

class LoanInsuranceBonificationsDetails extends React.Component {
    handleInsuranceRedirect(insurance, text) {
        const analyticsData = {
            categoriaEvento: window.utag_last_name,
            accionEvento: "bonificaciones",
            etiquetaEvento: `seguro de hogar/${text}`, // example: "repsol/ir a repsol"
        };
        recordLinkV2(analyticsData);
        this.props.history.push(insurance.link);
    }
    
    isValidSubType(productSubType) {
        return (
            productSubType === "807" ||
            productSubType === "808" ||
            productSubType === "809" ||
            productSubType === "810" ||
            productSubType === "811" ||
            productSubType === "812" ||
            productSubType === "814" ||
            productSubType === "815" ||
            productSubType === "816" ||
            productSubType === "817" ||
            productSubType === "818" ||
            productSubType === "819" ||
            productSubType === "820" ||
            productSubType === "821" ||
            productSubType === "822" 
        );
    }
    validateExistingMortgagesTwoView(productSubType) {
        return (
            productSubType === "807" ||
            productSubType === "808" ||
            productSubType === "809" ||
            productSubType === "810" ||
            productSubType === "811" ||
            productSubType === "812"
        );
    }

    validateExistingMortgagesFourView(productSubType) {
        return (
            productSubType === "814" ||
            productSubType === "815" ||
            productSubType === "816"
        );
    }

    validateExistingMortgagesNoView(productSubType) {
        return (
            productSubType === "801" ||
            productSubType === "802" ||
            productSubType === "803"
        );
    }

    validateExistingMortgagesThreeView(productSubType) {
        return (
            productSubType === "820" ||
            productSubType === "821" ||
            productSubType === "822" 
        );
    }

    validateExistingMortgagesAllView(productSubType) {
        return (
            productSubType === "817" ||
            productSubType === "818" ||
            productSubType === "819"
        );
    }

    render() {
        const { insurance, productSubType } = this.props;
        const isValidSubType = this.isValidSubType(productSubType);
        const isNewMortgageSubTypeNo = this.validateExistingMortgagesNoView(
            productSubType
        );
        const isNewMortgageSubTypeTwo = !this.validateExistingMortgagesTwoView(
            productSubType
        );
        const isNewMortgageSubTypeFour = this.validateExistingMortgagesFourView(
            productSubType
        );
        const isNewMortgageSubTypeAll = this.validateExistingMortgagesAllView(
            productSubType
        );
        const isNewMortgageSubTypeThree = this.validateExistingMortgagesThreeView(
            productSubType
        );

        const existingMortgageBonificationSubtitle = insurance ? (
            <span>
                {formatText(
                    "loanInsuranceDetail-bonificationsInsuranceCombined_subtitle1"
                )}
                <br />
                <div className="loan-insurance-detail__bonification-link">
                    <a
                        href={`${insurance.link}`}
                        target="_blank"
                        className="loan-insurance-detail__bonification-link"
                        onClick={() =>
                            this.handleInsuranceRedirect(
                                insurance,
                                formatText(
                                    "mortgageRequestDocumentationCenter-downloadIcon"
                                )
                            )
                        }
                    >
                        {formatText(
                            "mortgageRequestDocumentationCenter-downloadIcon"
                        )}
                    </a>
                </div>
            </span>
        ) : (
            formatText(
                "loanInsuranceDetail-bonificationsWithoutInsuranceCombined_subtitle2"
            )
        );
    
        return !isValidSubType || isNewMortgageSubTypeNo ? (
            <OKSectionBox className="loan-insurance-detail">
                <OKBoxTitle
                    value={formatText(
                        "loanInsuranceDetail-bonificationsTitleText"
                    )}
                />
                <br />
                <article>
                    {formatText("loanInsuranceDetail-bonificationsNoDataText")}
                </article>
            </OKSectionBox>
        ) : (
            <OKSectionBox className="loan-insurance-detail">
                <article>
                    <OKBoxTitle
                        value={formatText(
                            "loanInsuranceDetail-bonificationsTitleText"
                        )}
                    />
                </article>
                <OKInformativeList columns={1}>
                    <OKInformativeListItem
                        title={formatText(
                            "loanInsuranceDetail-bonificationsSubtitleText"
                        )}
                        className="loan-insurance-detail__bonification-subtitle"
                    />
                </OKInformativeList>
                <div className="loan-insurance-detail__message">
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title={formatText(
                                "loanInsuranceDetail-bonificationsWithoutInsuranceCombined_title1"
                            )}
                            bodyText={formatText(
                                "loanInsuranceDetail-bonificationsWithoutInsuranceCombined_subtitle1"
                            )}
                        />
                        <OKInformativeListItem
                            title={formatText(
                                "loanInsuranceDetail-bonificationsWithoutInsuranceCombined_title2"
                            )}
                            bodyText={existingMortgageBonificationSubtitle}
                        />
                    </OKInformativeList>
                    {isValidSubType && isNewMortgageSubTypeAll && (
                        <OKInformativeList columns={2}>
                            <OKInformativeListItem
                                title={formatText(
                                    "loanInsuranceDetail-newBonificationsWealth_title1"
                                )}
                                bodyText={formatText(
                                    "loanInsuranceDetail-newBonificationsWealth_subtitle1"
                                )}
                            />
                            <OKInformativeListItem
                                title={formatText(
                                    "loanInsuranceDetail-newBonificationsCard_title1"
                                )}
                                bodyText={formatText(
                                    "loanInsuranceDetail-newBonificationsCard_subtitle1"
                                )}
                            />
                        </OKInformativeList>
                    )}
                    {isValidSubType &&
                        (isNewMortgageSubTypeTwo ||
                            isNewMortgageSubTypeAll ||
                            isNewMortgageSubTypeFour ||
                            isNewMortgageSubTypeThree) && (
                            <OKInformativeList columns={2}>
                                <OKInformativeListItem
                                    title={formatText(
                                        "loanInsuranceDetail-newBonifications_title1"
                                    )}
                                    bodyText={formatText(
                                        "loanInsuranceDetail-newBonifications_subtitle1"
                                    )}
                                />
                            </OKInformativeList>
                        )}
                </div>
                <div className="loan-insurance-detail__message">
                    <OKMessage type="informative">
                        <FormattedText
                            value={
                                "loanInsuranceDetail-bonifications_footerText"
                            }
                        />
                    </OKMessage>
                </div>
            </OKSectionBox>
        );
    }
}

LoanInsuranceBonificationsDetails.propTypes = {
    insurance: PropTypes.object.isRequired,
    productSubType: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
};

export default withRouter(LoanInsuranceBonificationsDetails);
